import { KmkMA_CacheContainerBase } from "./base/kmkMA_CacheContainerBase";
import { KmkMACacheViewModel } from "./kmkMACacheViewModel";


export class KmkMA_KmkCacheContainer extends KmkMA_CacheContainerBase {
    constructor(models: Array<KmkMACacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
